import React from "react"
import "./styles.css"

const NoOptions = () => <div className="no-options">No options</div>

export default NoOptions
